module.exports = __webpack_public_path__ + "static/bike-a59ca81cb3786c6bc551eb5fb69c0bf1.png";